//
// # (Style) Cache
//
// Tracks the things about an entity that are not their data,
// e.g. UI state elements like their highlighted-ness and theme.
// I.e. things that generally dynamically turn into their `Style`.
//

import { Table } from "./table";

export class Cache<T> {
  private current_: T | null = null; // Cached computed value
  constructor(readonly table: Table<T>, readonly parent: HasCache) {}

  compute(): T {
    return Table.lookup(this.table, this.parent.highlighted); // Lookup the state based on highlighted status
  }

  invalidate() {
    this.current_ = null; // Invalidate the current state
  }

  get current(): T {
    // Compute the state if not cached
    if (!this.current_) this.current_ = this.compute();
    return this.current_;
  }

  get value(): T {
    return this.current;
  }

  // Alias for `value`. The level of generality vs specificity definitely goes back n forth here.
  // For the time being, the only really useful thing to put in these `value`s are styles.
  get style(): T {
    return this.current;
  }
}

interface HasCache {
  highlighted: boolean;
}
